import countriesData from '@data/countries.json';

export const countries = countriesData.map((country) => ({
  key: country.code,
  value: country.code,
  name: country.name,
}));
